module.exports = __webpack_public_path__ + "media/images/shopping-cart-19c60e8b.png";